export default function FileAlt(props) {
    const fill = props.fill ?? '#5d6376';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path
                fill={fill}
                d="M437.333 128H330.667c-5.888 0-10.667-4.8-10.667-10.667V10.667C320 4.779 315.221 0 309.333 0H96C78.357 0 64 14.357 64 32v448c0 17.643 14.357 32 32 32h320c17.643 0 32-14.357 32-32V138.667c0-5.888-4.779-10.667-10.667-10.667zm-10.666 352c0 5.867-4.779 10.667-10.667 10.667H96c-5.888 0-10.667-4.8-10.667-10.667V32c0-5.867 4.779-10.667 10.667-10.667h202.667v96c0 17.643 14.357 32 32 32h96V480z"
            />
            <path
                fill={fill}
                d="M444.864 131.136l-128-128c-4.16-4.16-10.923-4.16-15.083 0s-4.16 10.923 0 15.083l128 128c2.091 2.069 4.821 3.115 7.552 3.115s5.461-1.045 7.531-3.115c4.16-4.16 4.16-10.923 0-15.083z"
            />
        </svg>
    );
}
